import "./index.scss";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Link from "next/link";
import { useState } from "react";

interface AccordionItem {
  question: string;
  answer: string;
}

const accordionData: AccordionItem[] = [
  {
    question: "How long you are in this business?",
    answer: "We have been in this business for the last 15 years, so we have perfect experience in every relevant area. We will take the best care of you and assure you of the best food, quality, and cost.",
  },
  {
    question: "Do you provide Outdoor catering or not?",
    answer: "Yes, we provide Out-station catering very regularly.",
  },
  {
    question: "Do you charge for tasting?",
    answer: "Yes, but the tasting charges are very minimal and that too will be reimbursed from our end when you book the event with us.",
  },
  {
    question: "Are your prices final or can we negotiate?",
    answer: "Of course, we will try our best to match your budget and provide you the competitive pricing.",
  },
  {
    question: "Can you please send us your Ballroom and Catering setup pictures?",
    answer: "Sure, I'll share the pictures so that you'll be able to understand our expertise in a better way.",
  },
  {
    question: "Can you please share the contact numbers of your previous customers for reference?",
    answer: "Sure, we will provide you with multiple references so that you can discuss them and understand our expertise.",
  },
  {
    question: "Can you help us choose the menu for the event?",
    answer: "Of course, please share with us your preferences or the cuisine that you are looking for. I'll share the best possible suggested menu after discussing it with our Chef and team. If you prefer, we can schedule a conference call withour Main Chef in which you can have a detailed discussion about your menu requirements.",
  },
  {
    question: "Can you suggest to me some of your most popular or best-selling items?",
    answer: "Sure, I'll share with you the list of our most-sellable items which are very popular among guests.",
  },
  {
    question: "Do you do Ballroom decorations or not?",
    answer: "No, we're not doing decorations because every guest prefers different kinds of decoration according to their event. If you want, we can share our preferred decorators' contact information, you can connect with them.",
  },
  {
    question: "What types of Cuisine do you consider your specialty and your top areas of expertise?",
    answer: "We specialize in Indian, Indo-Chinese, Thai, Indian fusion, and Regional Indian Cuisine like Gujarati, Punjabi, Marathi, Bengali and much more",
  },
  {
    question: "What if my guests have special diets or food allergies and sensitivities?",
    answer: "That's completely fine, don't worry we are always taking the best care of that and will surely accommodate those concerns. Please let us know your allergic requirements before the event so that we can plan accordingly",
  },
  {
    question: "Do you have Bar options in the Ballroom, how does that work?",
    answer: "Yes, we do have that option, we will set the Bar inside the Ballroom, and you can take the packages as per your preference. We have three Bar packages: they are Basic, Traditional, and Premium.",
  },
  {
    question: "Do you provide full Catering?",
    answer: "Yes, we are providing full Catering If the client's budget allows us to do so",
  },
  {
    question: "Are you able to coordinate with the venue regarding equipment and Setup?",
    answer: "Yes, after the confirmation of the event and menu, we will schedule the site visit with the venue, so that we can have a detailed conversation about everything, and we'll be on the same page. And afterwards, we'll share the Equipment list with them which consists of the requirements of chafing dishes, Serving Materials, and cooking equipment.",
  },
  {
    question: "Do you have Insurance coverage and other licenses?",
    answer: "Yes, we have over 5 million for additional Insured Coverage and we carry all our licenses.",
  },
];

export default function Faq() {

  const [expanded, setExpanded] = useState<number | false>(0);

  const handleChange = (panel: number) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <>
      {/* FAQ Section */}

      <section id="faq" className="faq-area pb-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-3xl font-bold text-center text-red-900 uppercase">
            FAQ
          </h2>
          <div className="w-16 h-1 bg-red-900 mx-auto mb-6 mt-2">
          </div>


          {accordionData.map((item, index) => (
            <Accordion
              key={item?.question}
              expanded={expanded === index}
              onChange={handleChange(index)}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index}-content`}
                id={`panel${index}-header`}
              >
                <Typography component="span">{item.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                {item.answer}
                {index === 0 && (
                  <div className="mt-2">
                    <Link href="#home" className="px-3 py-2 bg-red-800 text-white rounded text-[14px] font-bold">
                      INQUIRE TODAY
                    </Link>
                  </div>
                )}
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      </section>
    </>
  )
}